import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCar, faMapMarkedAlt } from '@fortawesome/free-solid-svg-icons';
import NavigationButtons from './NavigationButtons';
import './NavigationButtons.css';
import './RouteDetails.css';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const RouteDetailsDrive = ({ 
  from, 
  to, 
  selectedRoute, 
  setShowDriveOverlay, 
  setSelectedRoute 
}) => {
  return (
    <div className="route-details-overlay">
      <div className="route-details-header">
        <div className="route-details-title">
          <FontAwesomeIcon icon={faCar} /> {from} to {to}
        </div>
        <button onClick={() => setShowDriveOverlay(false)} className="route-details-close-button">
          <FontAwesomeIcon icon={faArrowLeft} />
        </button>
      </div>

      {selectedRoute && (
        <div className="route-details-summary-card">
          <div className="route-details-journey-title">
            Route
          </div>

          <div className="route-details-duration-distance">
            ⏱ <strong>{selectedRoute.duration}</strong> &nbsp; • &nbsp; 📏 {selectedRoute.distance}
          </div>

          <div className="route-details-price">
            🧾 Fuel Cost: <strong>{selectedRoute.fare}</strong>
          </div>

          <div className="route-details-note">
            Estimated travel time with normal traffic.
          </div>
        </div>
      )}

      <NavigationButtons
        from={from}
        to={to}
        setSelectedRoute={setSelectedRoute}
        selectedRoute={selectedRoute}
        travelMode="driving"
      />
    </div>
  );
};

export default RouteDetailsDrive; 